/**
 * Page container (copied from web/src/components/navigation/PageContainer.tsx).
 *
 * Applies consistent responsive padding and a max width to page content.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function PageContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mx-auto w-full max-w-6xl space-y-6 p-4 sm:p-6 lg:p-8', className)}>{children}</div>;
}
